import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo/321VETS_LOGO.png";
import { User } from "lucide-react";

const Navbar = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav className="w-full border-b border-gray-300 bg-white text-[15px] font-sans">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-between px-4 py-2">
        {/* Left: Logo */}
        <a href="/" className="flex items-center">
          <img
            src={Logo}
            alt="321 Vets"
            className="h-8 w-auto"
            style={{ minWidth: 32 }}
          />
        </a>
        {/* Right: Links */}
        <div className="flex flex-row items-center gap-6">
          <a
            href="/post"
            className="text-blue-700 underline hover:text-blue-900"
          >
            post
          </a>
          {isLoggedIn && (
            <>
              <a
                href="/account"
                className="inline-flex items-center justify-center h-8 w-8 rounded-full border border-gray-300 hover:bg-gray-100"
              >
                <User className="h-5 w-5 text-blue-700" />
              </a>
              <a
                href="#logout"
                onClick={handleLogout}
                className="text-blue-700 underline hover:text-blue-900"
              >
                logout
              </a>
            </>
          )}
          {!isLoggedIn && (
            <>
              <a
                href="/login"
                className="text-blue-700 underline hover:text-blue-900"
              >
                login
              </a>
              <a
                href="/signup"
                className="text-blue-700 underline hover:text-blue-900"
              >
                sign up
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
